// Dependencies
import { z } from "zod";

// local imports
import request from "../base-request";

const meSchema = z.object({
	aliases: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
		})
	),
	authorization: z
		.object({
			payload: z.object({
				user_id: z.string(),
				company_id: z.string(),
				user_primary_role: z.string(),
			}),
			token: z.string(),
		})
		.nullable(),
	defaultCompanyID: z.string(),
	email: z.string(),
});

export const meResponseSchema = z.object({
	errors: z.array(z.string()),
	me: meSchema,
});

export type MeResponse = z.infer<typeof meResponseSchema>;
export type Me = z.infer<typeof meSchema>;

/**
 * Get the current logged in user.
 */
export const getCurrentUser = async () => {
	const [data] = await request("/api/me");
	return meResponseSchema.parse(data);
};

/**
 * Extends the current session. Doesn't return anything.
 * @returns
 */
export const extendSession = async () => {
	return request("/api/authentication/extend-session", {
		method: "POST",
	});
};
